<template>
  <filter-parent :title="title" :start-open="true" icon="clock">
    <div class="checkbox-wrapper column">
      <div
        v-for="availableTime in availableTimesOptions"
        :key="availableTime.id"
        class="checkbox"
      >
        <input
          :id="`available-time-checkbox-${availableTime.id}`"
          v-model="availableTimes"
          type="checkbox"
          :value="availableTime.id"
          autocomplete="off"
        />
        <label :for="`available-time-checkbox-${availableTime.id}`">{{
          availableTime.name
        }}</label>
      </div>
    </div>
  </filter-parent>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { startOfDay } from 'date-fns';
import {
  AVAILABLE_TIMES,
  AVAILABLE_TIMES_HOURS,
} from 'Constants/counselorGridFilters';
import { getThemeText } from 'Constants/themeVars';
import { getLocaleForIntl } from 'Library/dateHelper';
import FilterParent from '../common/FilterParent.vue';

export default defineComponent({
  name: 'AvailableTimesFilter',

  components: { FilterParent },

  data() {
    return {
      title: getThemeText(
        'counselorGridTexts.availableTimes',
        'Available times'
      ),
    };
  },

  computed: {
    availableTimes: {
      get() {
        return this.$store.state.counselorGrid.filteredAvailableTimes;
      },
      set(value) {
        this.$store.commit('counselorGrid/setFilteredAvailableTimes', value);
      },
    },

    morningLabel(): string {
      return this.formatLabel(
        getThemeText('counselorGridTexts.morning', 'Morning'),
        AVAILABLE_TIMES_HOURS[AVAILABLE_TIMES.MORNING]
      );
    },

    afternoonLabel(): string {
      return this.formatLabel(
        getThemeText('counselorGridTexts.afternoon', 'Afternoon'),
        AVAILABLE_TIMES_HOURS[AVAILABLE_TIMES.AFTERNOON]
      );
    },

    eveningLabel(): string {
      return this.formatLabel(
        getThemeText('counselorGridTexts.evening', 'Evening'),
        AVAILABLE_TIMES_HOURS[AVAILABLE_TIMES.EVENING]
      );
    },

    availableTimesOptions(): { id: string; name: string }[] {
      return [
        { id: AVAILABLE_TIMES.MORNING, name: this.morningLabel },
        { id: AVAILABLE_TIMES.AFTERNOON, name: this.afternoonLabel },
        { id: AVAILABLE_TIMES.EVENING, name: this.eveningLabel },
      ];
    },
  },

  methods: {
    formatLabel(
      label: string,
      hours: { startTime: string; endTime: string }
    ): string {
      return `${label} (${this.formatTime(hours.startTime)} - ${this.formatTime(hours.endTime)})`;
    },

    formatTime(time: string): string {
      const dateTime = startOfDay(new Date());
      dateTime.setHours(Number(time.split(':')[0]), Number(time.split(':')[1]));
      const dateTimeString = dateTime.toLocaleTimeString(getLocaleForIntl(), {
        hour: 'numeric',
      });

      return dateTimeString.toLocaleLowerCase().replace(' ', '');
    },
  },
});
</script>
